export default function getCanonicalUrl(
  path: string,
  baseUrl: string = URL_HOST,
) {
  if (!path) {
    return baseUrl;
  }

  if (path === '' || path === '/') {
    return baseUrl;
  }

  if (path.slice(-1) === '/') {
    return `${baseUrl}${path}`;
  }

  return `${baseUrl}${path}/`;
}
